<template>
  <aside
    class="not-logged-in-card"
    aria-labelledby="not-logged-in-card-title"
    aria-describedby="not-logged-in-card-copy"
  >
    <div class="card-orb card-orb--blue" aria-hidden="true"></div>
    <div class="card-orb card-orb--red" aria-hidden="true"></div>

    <span class="card-kicker">
      <i class="fa fa-shield-alt" aria-hidden="true"></i>
      Free intelligence unlock
    </span>

    <h2 id="not-logged-in-card-title">
      See what your feed is missing.
    </h2>

    <p id="not-logged-in-card-copy" class="card-copy">
      Get the Daily Cut, blindspot alerts, sentiment gap reads,
      and narrative movement before your algorithm flattens the story.
      Published Under Sniper picks are available on Limited and Full.
    </p>

    <div class="value-list" aria-label="Free account intelligence benefits">
      <span>
        <i class="fa fa-scale-balanced" aria-hidden="true"></i>
        Compare polarization
      </span>
      <span>
        <i class="fa fa-chart-line" aria-hidden="true"></i>
        Spot narrative movement
      </span>
      <span>
        <i class="fa fa-eye-slash" aria-hidden="true"></i>
        Catch blindspots outside your bubble
      </span>
      <span>
        <i class="fa fa-heart-pulse" aria-hidden="true"></i>
        Read the sentiment gap
      </span>
      <span>
        <i class="fa fa-crosshairs" aria-hidden="true"></i>
        Published picks on Limited and Full
      </span>
    </div>

    <div class="card-actions">
      <a class="primary-cta" href="/register" aria-label="Create a free account and get the Daily Cut">
        Get the Daily Cut Free
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </a>

      <a class="secondary-cta" href="/login" aria-label="Log in to your BarbershopTalk account">
        Already have an account? Log in
      </a>
    </div>

    <p class="trust-note">
      Free to start. No credit card. Built for readers who want every side and the emotional frame behind it.
      <span>The conversation starts here.</span>
    </p>
  </aside>
</template>

<script>
export default {
  name: "notLoggedInCard"
}
</script>

<style scoped>
.not-logged-in-card {
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  width: min(100%, 360px);
  margin: 0 auto;
  padding: 20px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 24px;
  background:
    radial-gradient(circle at top right, rgba(11, 126, 227, 0.14), transparent 34%),
    radial-gradient(circle at bottom left, rgba(221, 52, 52, 0.1), transparent 30%),
    linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(248, 251, 255, 0.96));
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.12);
  color: #0f172a;
  text-align: left;
}

.not-logged-in-card::before {
  position: absolute;
  inset: 0 0 auto;
  height: 6px;
  background: linear-gradient(90deg, #0b7ee3, #dd3434);
  content: "";
}

.card-orb {
  position: absolute;
  border-radius: 999px;
  filter: blur(2px);
  pointer-events: none;
}

.card-orb--blue {
  top: -34px;
  right: -34px;
  width: 112px;
  height: 112px;
  background: rgba(11, 126, 227, 0.13);
}

.card-orb--red {
  bottom: 70px;
  left: -48px;
  width: 108px;
  height: 108px;
  background: rgba(221, 52, 52, 0.09);
}

.card-kicker {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 12px;
  padding: 7px 10px;
  border: 1px solid rgba(11, 126, 227, 0.14);
  border-radius: 999px;
  background: rgba(239, 246, 255, 0.82);
  color: #0b65c2;
  font-size: 0.68rem;
  font-weight: 950;
  letter-spacing: 0.08em;
  line-height: 1;
  text-transform: uppercase;
}

.card-kicker i {
  color: #dd3434;
}

.not-logged-in-card h2 {
  position: relative;
  margin: 0;
  color: #0f172a;
  font-size: clamp(1.28rem, 4vw, 1.75rem);
  font-weight: 950;
  letter-spacing: -0.045em;
  line-height: 1.04;
}

.card-copy {
  position: relative;
  margin: 10px 0 0;
  color: #475569;
  font-size: 0.94rem;
  font-weight: 750;
  line-height: 1.45;
}

.value-list {
  position: relative;
  display: grid;
  gap: 8px;
  margin-top: 16px;
}

.value-list span {
  display: grid;
  align-items: center;
  grid-template-columns: 28px minmax(0, 1fr);
  gap: 9px;
  min-width: 0;
  padding: 10px;
  border: 1px solid rgba(11, 126, 227, 0.1);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.76);
  color: #1e293b;
  font-size: 0.78rem;
  font-weight: 850;
  line-height: 1.25;
}

.value-list i {
  display: inline-grid;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(11, 126, 227, 0.1);
  color: #0b7ee3;
  place-items: center;
  font-size: 0.8rem;
}

.card-actions {
  position: relative;
  display: grid;
  gap: 9px;
  margin-top: 18px;
}

.primary-cta,
.secondary-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 15px;
  text-decoration: none;
  font-weight: 950;
  transition: transform 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.primary-cta {
  min-height: 46px;
  padding: 12px 14px;
  background: linear-gradient(135deg, #0b7ee3, #0053ad);
  color: #ffffff;
  box-shadow: 0 14px 28px rgba(11, 126, 227, 0.24);
  font-size: 0.9rem;
}

.primary-cta:hover {
  color: #ffffff;
  box-shadow: 0 18px 34px rgba(11, 126, 227, 0.3);
  transform: translateY(-1px);
}

.primary-cta i {
  color: inherit;
  margin: 0;
}

.secondary-cta {
  min-height: 40px;
  padding: 10px 12px;
  background: #eef2f7;
  color: #0f172a;
  font-size: 0.82rem;
}

.secondary-cta:hover {
  background: #e2e8f0;
  color: #0f172a;
}

.trust-note {
  position: relative;
  margin: 12px 0 0;
  color: #64748b;
  font-size: 0.74rem;
  font-weight: 750;
  line-height: 1.35;
  text-align: center;
}

.trust-note span {
  display: block;
  margin-top: 6px;
  color: #0f172a;
  font-weight: 900;
  letter-spacing: 0.03em;
}

@media (max-width: 560px) {
  .not-logged-in-card {
    width: min(100%, 340px);
    padding: 18px;
    border-radius: 22px;
  }

  .card-kicker {
    font-size: 0.64rem;
  }

  .card-copy {
    font-size: 0.9rem;
  }

  .value-list span {
    padding: 9px;
  }

  .primary-cta {
    min-height: 48px;
  }
}

@media (max-width: 380px) {
  .not-logged-in-card {
    width: 100%;
    padding: 16px;
    border-radius: 20px;
  }

  .not-logged-in-card h2 {
    font-size: 1.42rem;
  }

  .value-list {
    gap: 7px;
  }

  .value-list span {
    padding: 8px;
    font-size: 0.74rem;
  }

  .trust-note {
    font-size: 0.7rem;
  }
}
</style>